// extracted by mini-css-extract-plugin
export default {"newBlogIcon":"NewBlogButton_newBlogIcon__KunJK","wrapper":"NewBlogButton_wrapper__WoL0C","fadeIn":"NewBlogButton_fadeIn__w1M0O"};